import { useResizeObserver as n } from "@placer-ui/hooks";
import { useMemo as r } from "react";
const i = 40, h = (e) => {
  const { containerRef: t, contentRect: s } = n(), o = r(
    () => s.height >= (e || i),
    [s.height, e]
  );
  return { containerRef: t, is2Liner: o };
};
export {
  h as useIsMessageTwoLine
};
//# sourceMappingURL=index.es571.js.map
